import { Capacitor } from "@capacitor/core";

// Central platform detection for the Capacitor shell. Every native-only code
// path in the web app gates on these helpers, so the same deployed bundle
// serves browsers (no-ops) and the iOS/Android shell (native behavior).

export function isNativeApp(): boolean {
  return Capacitor.isNativePlatform();
}

export function nativePlatform(): "ios" | "android" | null {
  if (!Capacitor.isNativePlatform()) return null;
  const p = Capacitor.getPlatform();
  return p === "ios" || p === "android" ? p : null;
}
